// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1UXKn","errorLogs":"styles_errorLogs__gNB_S"};